export default (editor, opts = {}) => {
    const DOMC = editor.DomComponents;
    const BM = editor.BlockManager;
    const TYPE = DOMC.getType('default');
    const MODEL = TYPE.model;
    const VIEW = TYPE.view;

    var model = MODEL.extend({

        defaults:{
            ...MODEL.prototype.defaults,
            name:"C-SELECT",
            "custom-name":"C-SELECT",
            tagName:"SELECT",
            droppable: false,
            attributes:{
                'data-slg-type':"C-SELECT",
                name:"default",
                placeholder:'Select an option'
            },
            classes:['form-control'],
            options:[],
            traits: [
                'placeholder',
                'name',
                {
                    type: 'checkbox',
                    name: 'required',
                }
            ]
        },
        setName(name){
            let component = this;
            component.addAttributes({
                name
            });
        },
        getName(){
            let component = this;
            let name = component.get('attributes')['name'];
            return name;
        },

        setPlaceholder(placeholder){
            let component = this;
            component.addAttributes({
                placeholder
            });
        },
        getPlaceholder(){
            let component = this;
            let placeholder = component.get('attributes')['placeholder'];
            return placeholder;
        },
        initPlaceholderOption(){
            let component = this;
            let component_option = component.components().at(0);
            let slg_type;
            if(component_option)
                slg_type = component_option.getAttributes()['data-slg-type'];
            if(component_option && slg_type == 'C-OPTION-PLACEHOLDER'){
                component.updatePlaceholderOption();
            }else{
                component.createPlaceholderOption();
            }
        },
        createPlaceholderOption(){
            let component = this;
            let placeholder = component.getAttributes()['placeholder'];
            let component_option = {
                tagName:'option',
                attributes:{
                    hidden:'',
                    selected:'',
                    'data-slg-type':'C-OPTION-PLACEHOLDER'
                },
                content:placeholder
            }
            component.append(component_option, { at:0 });
        },
        
        updatePlaceholderOption(){
            let component = this;
            let placeholder = component.getAttributes()['placeholder'];
            let component_option = component.components().at(0);
            component_option.set('content', placeholder);
            
        },
        formatOptions(){
            let component = this;
            let options = component.get('options');
            options = options.map((option, index)=>{
                let label = (option.label) ? option.label : option;
                let value = (option.value) ? option.value : option;
                let key = (option.key) ? option.key : index;
                return {
                    label,
                    value,
                    key
                }
            });
            component.set('options',options);
        },

        renderOptions() {
            let component = this
            let options = component.get('options');  
            component.empty();
            for (let i = 0; i < options.length; i++) {
                const option = options[i];
                
                component.addOption(option);
            }
        },

        renderOption(option){
            let component = this;
            let find = component.components().find(comp => {
                return option.key == comp.getId();
            });
            if(find){
                component.updateOption(option,find);
            }else{
                component.addOption(option)
            }
        },
        addOption(option, attributes = {}){
            let component = this;
            let option_component = {
                tagName:'option',
                attributes:{
                    value:option.value,
                    "data-key":option.key,
                    id:option.key,
                    ...attributes
                },
                content:option.label
            }
            component.append(option_component);
        },
        updateOption(option,component){
            let attributes = component.getAttributes();
            component.setAttributes({
                ...attributes,
                value:option.value
            });
            component.set("content",option.label);
        },
        deleteOption(option){
            let component = this;
            let find = component.components().find(comp => {
                return option.key == comp.getId();
            })
            find.remove();
        },

        init: function () {
            let component = this;
            this.listenTo(component, 'change:attributes:placeholder', component.updatePlaceholderOption);
        },
    },{
        isComponent(el) {
            if(el && el.getAttribute && el.getAttribute('data-slg-type') == "C-SELECT")
                return { type:'C-SELECT' }
        }
    });

    var view = VIEW.extend({
        onRender() {
            let component = this.model;
            component.formatOptions();
            // component.addPlaceholderOption();
            component.renderOptions();
            component.initPlaceholderOption();
        },
    });

    DOMC.addType('C-SELECT', {
      model:model,
      view:view,
    });

    /* BM.add('B-SELECT', {
        label:"SELECT",
        content: {
            type: 'C-SELECT',
        },
        category:"OTHERS",
    }); */


};
  